import { useQuery } from "react-query";
import { JobHttpService } from "../service";

const UseCompanyDetail = (companyId, options = {}) => {
    return useQuery(
        ["company_detail", companyId],
        () => JobHttpService.loadCompany(companyId),
        {
            enabled: Boolean(companyId),
            ...options
        }
    );
};

export default UseCompanyDetail;

